// eslint-disable-next-line max-classes-per-file
export class VersionError extends Error {
  name = 'VersionError';
}

export class Version {
  private readonly parts: number[];

  constructor(public raw: string, private divisor = '-') {
    this.parts = this.split(raw);
  }

  private split(versao: string) {
    return versao.split(this.divisor).map((num) => {
      if (/\D/.test(num)) throw new VersionError('Versão possui caracteres não numéricos');
      return parseInt(num, 10);
    });
  }

  isEqual(other: string | Version) {
    const otherParts = typeof other === 'string' ? this.split(other) : other.parts;
    return otherParts.length === this.parts.length
      && this.parts.every((p, i) => p === otherParts[i]);
  }

  isGreaterThan(other: string | Version) {
    const otherParts = typeof other === 'string' ? this.split(other) : other.parts;

    if (otherParts.length !== this.parts.length) {
      throw new VersionError('Versionamentos incompatíveis');
    }

    for (let i = 0; i < this.parts.length; i += 1) {
      const thisPart = this.parts[i];
      const thatPart = otherParts[i];
      if (thisPart > thatPart) return true;
      if (thisPart < thatPart) return false;
    }
    return false; // versões iguais
  }

  toJSON() {
    return this.raw;
  }
}

export const versoes = {
  politicaPrivacidade: new Version(appSettings.VUE_APP_VERSAO_POLITICA_PRIVACIDADE),
  termoUso: new Version(appSettings.VUE_APP_VERSAO_TERMO_USO),
};

export type Versao = keyof typeof versoes;
